import React from 'react';

interface IDeleteModalProps {
  title: string;
  subtitle: string;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAction: React.Dispatch<React.SetStateAction<boolean>>;
}

const Modal: React.FC<IDeleteModalProps> = ({
  title,
  subtitle,
  setIsOpenModal,
  setIsAction,
}) => {
  return (
    <div className='imm_admin__delete_modal'>
      <div className='delete_modal__container'>
        <div className='delete_modal__header'>
          <h4>{title}</h4>
          <p>{subtitle}</p>
        </div>
        <div className='delete_modal__actions'>
          <button className='modal__decline_btn' onClick={() => setIsOpenModal(false)}>
            Cancel
          </button>
          <button className='modal__accept_btn' onClick={() => { setIsOpenModal(false); setIsAction(true); }}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;